import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  ViewChild,
  signal,
} from '@angular/core';

import { BaseComponent } from '@ups/xplat/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ups-popover',
  templateUrl: 'popover.component.html',
  standalone: false,
})
export class PopoverComponent extends BaseComponent {
  @ViewChild('anchor') public anchor: ElementRef<HTMLElement>;
  @ViewChild('popup', { read: ElementRef })
  public popup: ElementRef<HTMLElement>;
  /** A signal because hosts close the popover from their own handlers via a template reference. */
  public readonly show = signal(false);

  @HostListener('keydown', ['$event'])
  public keydown(event: KeyboardEvent): void {
    if (event.keyCode === 27) {
      this.toggle(false);
    }
  }

  @HostListener('document:click', ['$event'])
  public documentClick(event: MouseEvent): void {
    if (!this.contains(event.target)) {
      this.toggle(false);
    }
  }

  public toggle(show?: boolean): void {
    this.show.set(show !== undefined ? show : !this.show());
  }

  private contains(target: EventTarget | null): boolean {
    if (!(target instanceof Node)) {
      return false;
    }

    return (
      this.anchor.nativeElement.contains(target) ||
      (this.popup ? this.popup.nativeElement.contains(target) : false)
    );
  }
}
